import Vue from 'vue';
import PasswordChangeRecover from './components/PasswordChangeRecover.vue';
import './element';

Vue.component('password-change-recover', PasswordChangeRecover);

new Vue({
    el: '#reset_change',
    data: {
        passwordChanged: false,
    }
});
